import { useEffect, useState } from 'react'
import * as ReactDOMServer from 'react-dom/server';
import api from "../../../services/api"
import { Chart } from "react-google-charts"
import { LoadComponent, Text } from '..'
import { calculatePercentage } from '../../../helpers/number/numberPercentage';
import { useApp } from '../../../contexts';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { getCoinCountryLabel, translateText } from '../../../helpers/util';

export const ComboChartMarketHistoryRentalPricesIndustrial = ({ title = "", industrialId, period = 12, comparativeUniverse, reloadTrigger }) => {

    const [industrialHistoryRentalPrices, setIIndustrialHistoryRentalPrices] = useState([])
    const [historyData, setHistoryData] = useState([])
    const [options, setOptions] = useState({})
    const [load, setLoad] = useState(true)
    const [pageLoaded, setPageLoaded] = useState(false)
    const { closeDialog, showDialog, language, translations, userCountry, buildingCountry } = useApp();

    useEffect(() => {
        if(comparativeUniverse !== null){
            loadHistoryRentalPrices()
        }
    }, [comparativeUniverse]);

    useEffect(() => {
        loadHistoryRentalPrices()
    }, [period, reloadTrigger]);

    const loadHistoryRentalPrices = async () => {
        setLoad(true)
        let url = `/industrial/${industrialId}/history/rentalprices?period=${period}`
        if(comparativeUniverse !== null){
            if(comparativeUniverse.classes.length > 0){
                url+=`&buildingsClass=${comparativeUniverse.classes.join(',')}`
            }
            if(comparativeUniverse.type.length > 0){
                url+=`&type=${comparativeUniverse.type.join(',')}`
            }
            if(comparativeUniverse.typeRegion == "radius"){
                url+=`&radius=${comparativeUniverse.radius}`
            }
        }
        const response = await api.get(url)
        const { industrialHistoryRentalPrices } = response.data
        setIIndustrialHistoryRentalPrices(industrialHistoryRentalPrices)

    }

    useEffect(() => {
        processData()
        setTimeout(() => {
            setLoad(false)
        }, 1500);
    }, [industrialHistoryRentalPrices]);

    useEffect(() => {
        if(load == true){
            setPageLoaded(true);
        }
    }, [load]);

    const processData = () => {

        if (industrialHistoryRentalPrices.length > 0){
            let history = [];
            let series = [
                { color: 'transparent', visibleInLegend: false, },
                { color: '#b7c7d8', visibleInLegend: false },
                { color: '#b7c7d8', p: { html: true } }
            ];
            let columns = [
                `${translateText("Trimestre", language, translations, userCountry)}`,
                "min",
                "max",
                { type: 'string', role: 'tooltip', p: { html: true } },
                `${translateText("Faixa de Preço Pedido do Entorno", language, translations, userCountry)} (${getCoinCountryLabel(buildingCountry)}/m²)`
            ]
            if (industrialHistoryRentalPrices.filter(item => item.media_preco_locacao).length > 0){
                columns.push(`${translateText("Média Preço Pedido do Edifício", language, translations, userCountry)} (${getCoinCountryLabel(buildingCountry)}/m²)`)
                columns.push({ type: 'string', role: 'tooltip', p: { html: true } })
            } 
            if (industrialHistoryRentalPrices.filter(item => item.vmti).length > 0){
                columns.push(`${translateText("Média de Valor Transacionado do Edifício", language, translations, userCountry)} (${getCoinCountryLabel(buildingCountry)}/m²)`)
                columns.push({ type: 'string', role: 'tooltip', p: { html: true } })
            }
            if (industrialHistoryRentalPrices.filter(item => item.vmtm).length > 0){
                columns.push(`${translateText("Média de Valor Transacionado do Entorno", language, translations, userCountry)} (${getCoinCountryLabel(buildingCountry)}/m²)`)
                columns.push({ type: 'string', role: 'tooltip', p: { html: true } })
            }
    
            history.push(columns)
    
            industrialHistoryRentalPrices.forEach(quarter => {
    
                let quarterData = [
                    `${quarter.trimestre}T ${quarter.ano}`,
                    quarter.min_preco_locacao_mercado ? quarter.min_preco_locacao_mercado : 0,
                    quarter.media_preco_locacao_mercado - quarter.min_preco_locacao_mercado,
                    getIndustrialMarketHistoryRentalPricesTooltip({ quarter }),
                    quarter.max_preco_locacao_mercado - quarter.media_preco_locacao_mercado
                ]
                if (industrialHistoryRentalPrices.filter(item => item.media_preco_locacao).length > 0){
                    quarterData.push(quarter.media_preco_locacao ? parseFloat(quarter.media_preco_locacao) : null)
                    quarterData.push(getindustrialHistoryRentalPricesTooltip(`${translateText("Média Preço Pedido do Edifício", language, translations, userCountry)} (${getCoinCountryLabel(buildingCountry)}/m²):`, `${quarter.trimestre}T ${quarter.ano}`, quarter.media_preco_locacao ? Math.ceil(quarter.media_preco_locacao) : "-"))
                }
                if (industrialHistoryRentalPrices.filter(item => item.vmti).length > 0){
                    quarterData.push(quarter.vmti ? parseFloat(quarter.vmti.vmti) : null)
                    quarterData.push(getindustrialHistoryRentalPricesTooltip(`${translateText("Média de Valor Transacionado do Edifício", language, translations, userCountry)} (${getCoinCountryLabel(buildingCountry)}/m²):`, `${quarter.trimestre}T ${quarter.ano}`, quarter.vmti ? Math.ceil(quarter.vmti.vmti) : "-"))
                } 
                
                if (industrialHistoryRentalPrices.filter(item => item.vmtm).length > 0){
                    quarterData.push(quarter.vmtm ? parseFloat(quarter.vmtm.vmtm) : null)
                    quarterData.push(getindustrialHistoryRentalPricesTooltip(`${translateText("Média de Valor Transacionado do Entorno", language, translations, userCountry)} (${getCoinCountryLabel(buildingCountry)}/m²):`, `${quarter.trimestre}T ${quarter.ano}`, quarter.vmtm ? Math.ceil(quarter.vmtm.vmtm) : "-"))
                } 
    
                
                history.push(quarterData)
            });
            if (industrialHistoryRentalPrices.filter(item => item.media_preco_locacao).length > 0){
                series.push({ type: 'scatter' });
            }
            if (industrialHistoryRentalPrices.filter(item => item.vmti).length > 0){
                series.push({ type: 'scatter', pointShape: 'star', pointSize: 18 });
            }
            if (industrialHistoryRentalPrices.filter(item => item.vmtm).length > 0){
                series.push({ type: 'scatter', pointShape: { type: 'star', sides: 4, dent: 0.4 }, color: "#6d9be8", pointSize: 14 });
            }
            
            const minValue = Math.min.apply(Math, industrialHistoryRentalPrices.map((item) => { return item.min_preco_locacao_mercado }));
            const maxValue = Math.max.apply(Math, industrialHistoryRentalPrices.map((item) => { return item.max_preco_locacao_mercado }));;
            const options = {
                legend: { position: 'bottom', maxLines: 2, alignment: 'middle' },
                colors: ['#32587D'],
                chartArea: {
                    width: '100%',
                    //height: '55%',
                    left: 50,
                    // top: 20
                },
                // hAxis: { slantedText: true},
                vAxis: { 
                    viewWindow: {
                        min: minValue - calculatePercentage(40, minValue),
                        max: maxValue + calculatePercentage(25, maxValue)
                    }
                },
                backgroundColor: {
                    'fill': 'transparent'
                },
                tooltip: { isHtml: true },
                isStacked: true,
                seriesType: 'bars',
                // pointShape: 'circle',
                series: series.map((item, index) => { return {...item} }),
            };
            let dadosValidados = validaDados();
            if (history[0].length > 1 && dadosValidados.length > 0) {
                console.log(history);
                setHistoryData(history)
                setOptions(options)
            }
        }
    }

    const validaDados = () => {
        return industrialHistoryRentalPrices.filter((item) => {
            if(item.max_preco_locacao_mercado == null
            && item.media_preco_locacao == null
            && item.media_preco_locacao_mercado == null
            && item.min_preco_locacao_mercado == null
            && item.vmti == null
            && item.vmtm == null){
                return false;
            }else{
                return true;
            }
        })
    }

    const getIndustrialMarketHistoryRentalPricesTooltip = ({ quarter }) => {

        const htmlString = ReactDOMServer.renderToStaticMarkup(
            <div>
                <div>
                    {`${translateText("Faixa de Preço Pedido do Entorno", language, translations, userCountry)} (${getCoinCountryLabel(buildingCountry)}/m²): `} <b>{Math.round(quarter.min_preco_locacao_mercado)}</b> - <b>{Math.round(quarter.max_preco_locacao_mercado)}</b>
                </div>
                <div>
                    {`${translateText("Média de Preço Pedido do Entorno", language, translations, userCountry)} (${getCoinCountryLabel(buildingCountry)}/m²): `}<b>{Math.round(quarter.media_preco_locacao_mercado)}</b>
                </div>
            </div>
        );
        return htmlString
    }
    
    const getindustrialHistoryRentalPricesTooltip = (text, trimestreAno, value) => {
        const htmlString = ReactDOMServer.renderToStaticMarkup(
            <div>
                <div>
                    <b>{trimestreAno}</b> 
                    <br />
                    {text} <b>{value}</b>
                </div>
            </div>
        );
        return htmlString
    }
    const handleZoomChart = () => {
        const opt = {...options};
        opt.chartArea.top = 50;
        showDialog({
            component: <Chart
                chartType="ComboChart"
                data={historyData}
                options={opt}
                width={'100%'}
                height={445}
            />,
            showCancelButton: false,
            showConfirmButton: false,
            handleConfirm: () => closeDialog()
        })
    }

    return (
        // <LoadComponent isLoading={load}>
        <>
            {historyData.length > 0 && (
                <div style={{ position: 'relative'}}>
                    <ZoomInIcon style={styles.iconZoom} onClick={handleZoomChart} />
                    <Chart
                        chartType="ComboChart"
                        data={historyData}
                        options={options}
                        width={'100%'}
                        height={280}
                    />          
                </div>     
            )}


            { historyData.length == 0 && pageLoaded == true && (
                <div style={styles.emptyData}>
                    {translateText("Sem dados para montar gráfico", language, translations, userCountry)}
                </div>
            )}
        </> 
        // </LoadComponent>
    )
}

const styles = {
    title: {
        fontSize: "14px",
        fontWeight: "600",
        color: "#7a7b7c"
    },
    emptyData:{
        textAlign: "center",
    },
    iconZoom: {
        position: 'absolute', 
        right: 10, 
        top: 10, 
        zIndex: 1, 
        cursor: "pointer", 
        width: 30, 
        height: 30,
        color: "#32587D"
    }
}